export default {
  "cells": [
    // {
    //   "cell_type": "markdown",
    //   "metadata": {},
    //   "source": [
    //     "## 标题"
    //   ]
    // },
    // {
    //   "cell_type": "code",
    //   "execution_count": null,
    //   "metadata": {
    //     "collapsed": true
    //   },
    //   "outputs": [],
    //   "source": [
    //     "train_data = pd.read_csv('../../data/kaggle_house/train.csv')\n",
    //     "test_data = pd.read_csv('../../data/kaggle_house/test.csv')"
    //   ]
    // },
  ],
  "metadata": {
    "kernelspec": {
      "display_name": "Python 3",
      "language": "python",
      "name": "python3"
    },
    "language_info": {
      "codemirror_mode": {
        "name": "ipython",
        "version": 3
      },
      "file_extension": ".py",
      "mimetype": "text/x-python",
      "name": "python",
      "nbconvert_exporter": "python",
      "pygments_lexer": "ipython3",
      "version": "3.6.2"
    }
  },
  "nbformat": 4,
  "nbformat_minor": 2
}



// WEBPACK FOOTER //
// ./src/components/js/ipynb.js